const env = window._env_;

export const getEnvValue = name => {
  return env[name];
};

export const getEnv = () => {
  return env;
};
